/* eslint-disable @next/next/no-img-element */
import React from "react";

const RegisterFields = ({
    regStep,
    onSubmit,
    isSigningIn,
    setEmail,
    email,
    onGoogleSignIn,
    onAppleSignIn,
    errorMessage,
    handleSteps,
    switchMode,
    password,
    setPassword,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    nickname,
    setNickname,
    isAdult,
    setIsAdult,
    isSigningUp,
    // New preference states
    termsAndConditions,
    setTermsAndConditions,
    privacyPolicy,
    setPrivacyPolicy,
    marketingEmails,
    setMarketingEmails,
    ambassadorProgram,
    setAmbassadorProgram,
    analytics,
    setAnalytics,
}: any) => {
    return (
        <>
            {regStep !== "confirmation" && regStep !== "confirmed" && regStep !== "checkout_success" && (
                <form onSubmit={onSubmit} className="space-y-4">
                    <h3 className="font-heading text-gray-800 text-xl font-semibold sm:text-2xl mt-2 text-center">
                        Registrati a <span className="text-[#EA5D39]">Babalù®</span>
                    </h3>

                    {/* STEP 1: email */}
                    {regStep === "email" && (
                        <>
                            {/* Pulsanti Google / Apple */}
                            <div className="flex flex-col space-y-3 mt-4 font-paragraph">
                                <button
                                    disabled={isSigningIn}
                                    onClick={onGoogleSignIn}
                                    className={`
                        flex items-center justify-center gap-x-2 border border-gray-300 rounded-md py-2 
                        hover:bg-gray-50 transition 
                        ${isSigningIn ? "cursor-not-allowed opacity-60" : ""}
                      `}
                                >
                                    <img
                                        src="/assets/google-modale.svg"
                                        alt="Google"
                                        className="w-5 h-5"
                                    />
                                    <span className="text-sm font-medium">
                                        {isSigningIn ? "Signing In..." : "Procedi con Google"}
                                    </span>
                                </button>

                                <button
                                    disabled={isSigningIn}
                                    onClick={onAppleSignIn}
                                    className={`
                        flex items-center justify-center gap-x-2 border border-gray-300 rounded-md py-2
                        bg-black text-white hover:bg-gray-800 transition
                        ${isSigningIn ? "cursor-not-allowed opacity-60" : ""}
                      `}
                                >
                                    <img
                                        src="/assets/apple-modale.svg"
                                        alt="Apple"
                                        className="w-5 h-5"
                                    />
                                    <span className="text-sm font-medium">
                                        {isSigningIn ? "Signing In..." : "Procedi con Apple"}
                                    </span>
                                </button>

                                <button
                                    type="button"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleSteps("profile");
                                    }}
                                    className="
                      w-full
                      bg-[#026E78FF]
                      text-white
                      py-2
                      rounded
                      hover:bg-[#027E78FF]
                      transition
                      text-sm font-medium
                    "
                                >
                                    Registrati usando la tua email
                                </button>
                            </div>
                        </>
                    )}

                    {/* STEP 2: Nome, Cognome, Nome utente, email, password ,checkbox, bottone “Completa” */}
                    {regStep === "profile" && (
                        <>

                            {/* NOME */}
                            <div className="mt-4 font-paragraph">
                                <label className="block text-sm text-gray-700 font-bold mb-1">
                                    Nome
                                </label>
                                <input
                                    type="text"
                                    placeholder="Inserisci il tuo nome"
                                    required
                                    className="
                        w-full mt-1 px-3 py-2 text-gray-700 bg-white
                        border border-gray-300 rounded-lg
                        focus:ring-1 focus:ring-[#EA5D39]
                      "
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                />
                            </div>

                            {/* COGNOME */}
                            <div className="font-paragraph">
                                <label className="block text-sm text-gray-700 font-bold mb-1">
                                    Cognome
                                </label>
                                <input
                                    type="text"
                                    required
                                    placeholder="Inserisci il tuo cognome"
                                    className="
                        w-full mt-1 px-3 py-2 text-gray-700 bg-white
                        border border-gray-300 rounded-lg
                        focus:ring-1 focus:ring-[#EA5D39]
                      "
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                />
                            </div>

                            {/* NOME UTENTE */}
                            <div className="font-paragraph">
                                <label className="block text-sm text-gray-700 font-bold mb-1">
                                    Nome utente
                                </label>
                                <input
                                    type="text"
                                    required
                                    placeholder="Crea il tuo nome utente"
                                    className="
                        w-full mt-1 px-3 py-2 text-gray-700 bg-white
                        border border-gray-300 rounded-lg
                        focus:ring-1 focus:ring-[#EA5D39]
                      "
                                    value={nickname}
                                    onChange={(e) => setNickname(e.target.value)}
                                />
                            </div>

                            {/* Campo E-mail */}
                            <div className="font-paragraph">
                                <label className="block text-sm text-gray-700 font-bold mb-1">
                                    Indirizzo e-mail
                                </label>
                                <input
                                    type="email"
                                    autoComplete="email"
                                    required
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="w-full mt-1 px-3 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg focus:ring-1 focus:ring-[#EA5D39]"
                                    placeholder="Inserisci il tuo indirizzo e-mail"
                                />
                            </div>

                            {/* Campo Password */}
                            <div className="mt-4 font-paragraph">
                                <label className="block text-sm text-gray-700 font-bold mb-1">
                                    Password
                                </label>
                                <input
                                    type="password"
                                    autoComplete="current-password"
                                    required
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="w-full mt-1 px-3 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg focus:ring-1 focus:ring-[#EA5D39]"
                                    placeholder="Inserisci la tua password"
                                />
                            </div>

                            {/* CHECKBOX: Dichiaro di essere maggiorenne */}
                            <div className="flex items-start mt-4 font-paragraph">
                                <input
                                    id="isAdult"
                                    type="checkbox"
                                    className="w-4 h-4 text-[#EA5D39] border-gray-300 focus:ring-[#EA5D39] mt-1 flex-shrink-0"
                                    checked={isAdult}
                                    onChange={() => setIsAdult(!isAdult)}
                                />
                                <label htmlFor="isAdult" className="ml-2 text-sm text-gray-700 cursor-pointer">
                                    Dichiaro di essere maggiorenne
                                </label>
                            </div>

                            {/* CHECKBOX OBBLIGATORIO: Termini e Condizioni */}
                            <div className="flex items-start mt-4 font-paragraph">
                                <input
                                    id="termsAndConditions"
                                    type="checkbox"
                                    className="w-4 h-4 text-[#EA5D39] border-gray-300 focus:ring-[#EA5D39] mt-1 flex-shrink-0"
                                    checked={termsAndConditions}
                                    onChange={() => setTermsAndConditions(!termsAndConditions)}
                                />
                                <label htmlFor="termsAndConditions" className="ml-2 text-sm text-gray-700 cursor-pointer">
                                    Dichiaro di aver letto e accettato i{" "}
                                    <a
                                        href="/termini-e-condizioni"
                                        target="_blank"
                                        className="text-[#026E78FF] hover:underline"
                                    >
                                        termini e condizioni
                                    </a>{" "}
                                    dell&apos;app Babalù®.{" "}
                                    <span className="text-red-500">*</span>
                                </label>
                            </div>

                            {/* CHECKBOX OBBLIGATORIO: Privacy Policy */}
                            <div className="flex items-start mt-4 font-paragraph">
                                <input
                                    id="privacyPolicy"
                                    type="checkbox"
                                    className="w-4 h-4 text-[#EA5D39] border-gray-300 focus:ring-[#EA5D39] mt-1 flex-shrink-0"
                                    checked={privacyPolicy}
                                    onChange={() => setPrivacyPolicy(!privacyPolicy)}
                                />
                                <label htmlFor="privacyPolicy" className="ml-2 text-sm text-gray-700 cursor-pointer">
                                    Dichiaro di aver letto l&apos;{" "}
                                    <a
                                        href="/privacy-policy"
                                        target="_blank"
                                        className="text-[#026E78FF] hover:underline"
                                    >
                                        informativa della privacy
                                    </a>{" "}
                                    e acconsento al trattamento dei miei dati personali per finalità legate all&apos;utilizzo dell&apos;app.{" "}
                                    <span className="text-red-500">*</span>
                                </label>
                            </div>

                            {/* CHECKBOX OPZIONALE: Marketing Emails */}
                            <div className="flex items-start mt-4 font-paragraph">
                                <input
                                    id="marketingEmails"
                                    type="checkbox"
                                    className="w-4 h-4 text-[#EA5D39] border-gray-300 focus:ring-[#EA5D39] mt-1 flex-shrink-0"
                                    checked={marketingEmails}
                                    onChange={(e) => {
                                        setMarketingEmails(e.target.checked);
                                        // Se disabilito marketing emails, disabilito anche ambassador program
                                        if (!e.target.checked) {
                                            setAmbassadorProgram(false);
                                        }
                                    }}
                                />
                                <label htmlFor="marketingEmails" className="ml-2 text-sm text-gray-700 cursor-pointer">
                                    Acconsento a ricevere comunicazioni promozionali e di marketing da parte di Babalù® (email, notifiche push o altri canali). Il consenso è facoltativo e revocabile in qualsiasi momento.
                                </label>
                            </div>

                            {/* CHECKBOX OPZIONALE: Ambassador Program */}
                            <div className="flex items-start mt-4 font-paragraph">
                                <input
                                    id="ambassadorProgram"
                                    type="checkbox"
                                    className={`w-4 h-4 text-[#EA5D39] border-gray-300 focus:ring-[#EA5D39] mt-1 flex-shrink-0 ${
                                        !marketingEmails ? 'opacity-50 cursor-not-allowed' : ''
                                    }`}
                                    checked={ambassadorProgram}
                                    disabled={!marketingEmails}
                                    onChange={(e) => {
                                        setAmbassadorProgram(e.target.checked);
                                        // Se accetta il programma ambassador, deve accettare anche le email di marketing
                                        if (e.target.checked) {
                                            setMarketingEmails(true);
                                        }
                                    }}
                                />
                                <label htmlFor="ambassadorProgram" className={`ml-2 text-sm ${
                                    !marketingEmails ? 'text-gray-400 cursor-not-allowed' : 'text-gray-700 cursor-pointer'
                                }`}>
                                    Voglio aderire al programma ambassador per ricevere aggiornamenti sulle campagne di promozione e contribuire alla diffusione di Babalù® come testimonial. Acconsento a essere contattato a tal fine.
                                </label>
                            </div>

                            {/* CHECKBOX OPZIONALE: Analytics */}
                            <div className="flex items-start mt-4 font-paragraph">
                                <input
                                    id="analytics"
                                    type="checkbox"
                                    className="w-4 h-4 text-[#EA5D39] border-gray-300 focus:ring-[#EA5D39] mt-1 flex-shrink-0"
                                    checked={analytics}
                                    onChange={(e) => setAnalytics(e.target.checked)}
                                />
                                <label htmlFor="analytics" className="ml-2 text-sm text-gray-700 cursor-pointer">
                                    Vuoi aiutarci a migliorare e personalizzare la tua esperienza, acconsentendo a che l&apos;app tenga traccia delle mie attività (come ricerche, acquisti o preferenze), per ottimizzare l&apos;App, condurre analisi statistiche e/o per mostrarmi contenuti su misura? <a href="/privacy-policy" target="_blank" className="primary-dark-color link-promozionali underline">Leggi l&apos;informativa</a>
                                </label>
                            </div>

                            {/* Errore eventuale */}
                            {errorMessage && (
                                <span className="font-paragraph text-red-600 font-bold block mt-2">
                                    {errorMessage}
                                </span>
                            )}

                            {/* Bottone “Completa” (submit effettivo) */}
                            <button
                                type="submit"
                                disabled={isSigningUp}
                                className={`
                      w-full 
                      mt-4
                      bg-[#026E78FF] 
                      text-white 
                      py-2 
                      rounded 
                      hover:bg-[#027E78FF]
                      transition
                      font-paragraph
                      ${isSigningUp ? "cursor-not-allowed opacity-60" : ""}
                    `}
                            >
                                {isSigningUp ? "Registrazione in corso..." : "Completa"}
                            </button>
                        </>
                    )}
                    {/* Link “Hai già un account? Accedi” */}
                    <div className="text-center text-sm font-paragraph pt-2">
                        <span className="text-gray-700">Hai già un account? </span>
                        <button
                            onClick={switchMode}
                            className="font-medium text-[#EA5D39] hover:underline"
                        >
                            Accedi
                        </button>
                    </div>
                </form>
            )}
        </>
    )
};

export default RegisterFields;
